/* Acumen homepage configurator — swaps the stage photo when a wax finish or leg style is picked.
   Photos: one per leg × finish (Shopify Files, configure-{leg}-{finish}.jpg). A missing combination
   keeps that leg's photo in another finish and the finish tag names what is actually shown. */
(function () {
  var CDN = 'https://cdn.shopify.com/s/files/1/0017/0695/0720/files/';
  var LEGS = {
    'x-frame':   { name: 'blencathra', url: '/products/blencathra-industrial-dining-table-x-frame-leg' },
    'v-frame':   { name: 'grasmoor',   url: '/products/grasmoor-rustic-dining-table-v-frame-leg' },
    'spider':    { name: 'grisedale',  url: '/products/grisedale-rustic-dining-table-spider-leg' },
    'trapezium': { name: 'glenridding', url: '/products/industrial-box-leg-table-table-b' },
    'square':    { name: 'helvellyn',  url: '/products/industrial-box-section-leg-table-table-d' }
  };
  var FINISHES = { clear: 'clear', lime: 'lime', grey: 'grey wash', forest: 'forest brown', antique: 'antique oak', rugger: 'rugger brown', jacobean: 'jacobean' };
  var MISSING = {};
  var FALLBACK_ORDER = ['antique', 'clear', 'forest', 'rugger', 'lime', 'jacobean', 'grey'];

  function finishSlug(name) {
    var n = (name || '').toLowerCase();
    if (n.indexOf('clear') > -1) return 'clear';
    if (n.indexOf('lime') > -1) return 'lime';
    if (n.indexOf('grey') > -1) return 'grey';
    if (n.indexOf('forest') > -1) return 'forest';
    if (n.indexOf('antique') > -1) return 'antique';
    if (n.indexOf('rugger') > -1) return 'rugger';
    if (n.indexOf('jacobean') > -1) return 'jacobean';
    return null;
  }
  function legSlug(name) {
    var n = (name || '').toLowerCase();
    if (n.indexOf('x') === 0) return 'x-frame';
    if (n.indexOf('v') === 0) return 'v-frame';
    if (n.indexOf('spider') > -1) return 'spider';
    if (n.indexOf('trap') > -1 || n.indexOf('trestle') > -1) return 'trapezium';
    if (n.indexOf('square') > -1) return 'square';
    return null;
  }
  function has(leg, fin) { return !MISSING[leg + '-' + fin]; }
  function src(leg, fin, w) { return CDN + 'configure-' + leg + '-' + fin + '.jpg?width=' + w; }

  function init(root) {
    var stage = root.querySelector('.cf-stage');
    var img = stage && stage.querySelector('img');
    if (!stage || !img) return;
    var tagFinish = root.querySelector('.cf-a1 .tick');
    var tagFell = root.querySelector('.cf-fell');
    var cta = root.querySelector('.cf-body a.cf-btn.solid');
    var sws = root.querySelectorAll('.cf-sw');
    var legs = root.querySelectorAll('.cf-leg');

    var state = {
      finish: finishSlug(tagFinish && tagFinish.textContent) || 'antique',
      leg: 'v-frame'
    };
    if (tagFell) {
      var fell = tagFell.textContent.toLowerCase();
      for (var k in LEGS) if (fell.indexOf(LEGS[k].name) > -1) state.leg = k;
    }

    var style = document.createElement('style');
    style.textContent =
      '[data-acumen-configure] .cf-sw,[data-acumen-configure] .cf-leg{cursor:pointer;transition:box-shadow .15s,border-color .15s}' +
      '[data-acumen-configure] .cf-sw.is-on{box-shadow:0 0 0 2px #fff,0 0 0 4px #2f3a24}' +
      '[data-acumen-configure] .cf-leg.is-on{border-color:#2f3a24;box-shadow:0 0 0 1px #2f3a24;background:#fff}' +
      '[data-acumen-configure] .cf-sw:focus-visible,[data-acumen-configure] .cf-leg:focus-visible{outline:2px solid #b08a4f;outline-offset:3px}' +
      '[data-acumen-configure] .cf-stage img{transition:opacity .25s ease}' +
      '[data-acumen-configure] .cf-stage img.is-fading{opacity:.35}';
    document.head.appendChild(style);

    function mark() {
      sws.forEach(function (el) {
        var on = finishSlug(el.getAttribute('title')) === state.finish;
        el.classList.toggle('is-on', on); el.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      legs.forEach(function (el) {
        var on = legSlug(el.getAttribute('title')) === state.leg;
        el.classList.toggle('is-on', on); el.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    function render() {
      var shown = state.finish;
      if (!has(state.leg, shown)) {
        for (var i = 0; i < FALLBACK_ORDER.length; i++) if (has(state.leg, FALLBACK_ORDER[i])) { shown = FALLBACK_ORDER[i]; break; }
      }
      var s1 = src(state.leg, shown, 800), s2 = src(state.leg, shown, 1200), s3 = src(state.leg, shown, 1600);
      var pre = new Image();
      img.classList.add('is-fading');
      pre.onload = pre.onerror = function () {
        img.removeAttribute('srcset'); img.removeAttribute('sizes');
        img.setAttribute('srcset', s1 + ' 800w, ' + s2 + ' 1200w, ' + s3 + ' 1600w');
        img.setAttribute('sizes', '(min-width: 990px) 50vw, 100vw');
        img.src = s2;
        img.alt = 'Rustic pine dining table with ' + state.leg.replace('-', ' ') + ' legs in ' + FINISHES[shown] + ' wax';
        img.classList.remove('is-fading');
      };
      pre.src = s2;
      if (tagFinish) tagFinish.textContent = FINISHES[shown];
      if (tagFell) tagFell.innerHTML = '◦ &nbsp;' + LEGS[state.leg].name;
      if (cta && root.getAttribute('data-cf-touched')) cta.setAttribute('href', LEGS[state.leg].url);
      mark();
    }

    function wire(list, key, slugFn) {
      list.forEach(function (el) {
        var slug = slugFn(el.getAttribute('title'));
        if (!slug) return;
        if (el.tagName === 'SPAN') { el.setAttribute('role', 'button'); el.setAttribute('tabindex', '0'); }
        function pick(e) {
          if (e) e.preventDefault();
          state[key] = slug; root.setAttribute('data-cf-touched', '1'); render();
        }
        el.addEventListener('click', pick);
        el.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') pick(e); });
      });
    }
    wire(sws, 'finish', finishSlug);
    wire(legs, 'leg', legSlug);
    mark();

    // warm the cache for the current leg so finish clicks feel instant
    setTimeout(function () {
      Object.keys(FINISHES).forEach(function (f) { if (has(state.leg, f)) { var p = new Image(); p.src = src(state.leg, f, 1200); } });
    }, 2500);
  }

  function boot() { document.querySelectorAll('[data-acumen-configure]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
